module.exports = "<md-dialog-content class=\"dialog_view_cv\">\n  <div class=\"col-md-12 text-right btn_close\">\n    <span class=\"subtitle\" md-dialog-close style=\"cursor:pointer;\" (click)=\"dialogRef.close('yes')\">Cerrar <b>X</b></span>\n  </div>\n\n  <app-cv [userId]=\"userId\" [job]=\"job\"></app-cv>\n</md-dialog-content>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-cv/view-cv.component.html
// module id = ../../../../../src/app/pages/view-cv/view-cv.component.html
// module chunks = main